import React from 'react';
import { Building2, Package, Wrench, CheckCircle2 } from 'lucide-react';
export function CommercialStrip() {
  return <section className="bg-brand-goldWash text-brand-charcoal py-16 lg:py-24" data-id="element-220" data-mp="3pfo19wuw9kld">
      <div className="max-w-7xl mx-auto px-4" data-id="element-221" data-mp="3kn36ot45z3gs">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center" data-id="element-222" data-mp="3km1s4enxvyub">
          <div className="lg:col-span-5" data-id="element-223" data-mp="3fojj6o9x9jmb">
            <span className="text-brand-charcoal font-bold tracking-wider uppercase text-xs mb-4 block flex items-center gap-2" data-id="element-224" data-mp="3apgqm3b4p5v8">
              <span className="w-6 h-px bg-brand-charcoal" data-id="element-225" data-mp="35pkj3u382wax"></span>
              B2B & Community Projects
            </span>
            <h2 className="text-3xl lg:text-4xl font-serif font-bold mb-6 leading-tight" data-id="element-226" data-mp="31pk3i64e0f2a">
              Commercial mailbox projects need more than a product grid
            </h2>
            <p className="text-brand-charcoal/90 text-lg mb-6 leading-relaxed" data-id="element-227" data-mp="zwm57urucu9y">
              Commercial mailbox requirements can vary by product, location,
              delivery setup, USPS/project requirements, and installation type.
              MidAtlantic helps property managers, HOAs, developers, apartments,
              and offices think through door counts, parcel lockers, numbering,
              replacement parts, and project planning before the order is
              placed.
            </p>

            <ul className="space-y-3 mb-8 text-brand-charcoal/80 text-sm" data-id="element-228" data-mp="3bsc4mvw8f2qi">
              <li className="flex items-start gap-2" data-id="element-229" data-mp="3bquhbrv63lt">
                <CheckCircle2 size={18} className="text-brand-maroon shrink-0 mt-0.5" data-id="element-230" data-mp="3eczp4ra870v" />
                <span data-id="element-231" data-mp="3psd3k5sxs03c">Free commercial estimating and diagnostic help</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-232" data-mp="3uq4yz9ssi4ca">
                <CheckCircle2 size={18} className="text-brand-maroon shrink-0 mt-0.5" data-id="element-233" data-mp="3uojzd5rmbv7k" />
                <span data-id="element-234" data-mp="r23al9x9j6nh">CBU, 4C, and parcel locker planning</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-235" data-mp="10xjyqa6mjoe2">
                <CheckCircle2 size={18} className="text-brand-maroon shrink-0 mt-0.5" data-id="element-236" data-mp="10x1ryjmc5rrw" />
                <span data-id="element-237" data-mp="qzduhlxci661">Replacement locks, doors, hinges, and parts</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-238" data-mp="r1751cb2xajb">
                <CheckCircle2 size={18} className="text-brand-maroon shrink-0 mt-0.5" data-id="element-239" data-mp="lzhpbjcww8ow" />
                <span data-id="element-240" data-mp="i0iqmghrx85w">USPS/project requirement awareness</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-241" data-mp="d6o99jpn559z">
                <CheckCircle2 size={18} className="text-brand-maroon shrink-0 mt-0.5" data-id="element-242" data-mp="8837vgynkfjy" />
                <span data-id="element-243" data-mp="3bmk4nvd837e">Community route and development planning</span>
              </li>
            </ul>

            <div className="flex flex-wrap gap-4" data-id="element-244" data-mp="3ufbaibi6u8ca">
              <a href="/6m8/commercial-mailboxes-lockers.html" className="bg-brand-maroon hover:bg-brand-maroonDark text-white px-6 py-3 rounded-md font-bold transition-colors shadow-sm" data-id="element-245" data-mp="3qe95fe1lb22e">
                Shop commercial mailboxes
              </a>
              <a href="/ContactUs.html" className="bg-white hover:bg-brand-goldSoft border border-brand-charcoal/20 text-brand-charcoal px-6 py-3 rounded-md font-semibold transition-colors" data-id="element-246" data-mp="2ewn4ytgfo0jx">
                Request project help
              </a>
            </div>
          </div>

          <div className="lg:col-span-7" data-id="element-247" data-mp="1r8c964plgr2i">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 lg:gap-6" data-id="element-248" data-mp="1r57yqpljcz3e">
              <a href="/6m8/commercial-mailboxes-lockers/centralized-delivery-mailboxes-and-kiosks.html" className="bg-white border border-brand-border hover:border-brand-maroon/40 hover:shadow-sm transition-all rounded-xl p-6 lg:p-8 flex flex-col items-center text-center group" data-id="element-249" data-mp="1w5cegdemdpsk">
                <div className="w-14 h-14 bg-brand-goldSoft text-brand-maroon rounded-full flex items-center justify-center mb-5 group-hover:scale-110 transition-transform" data-id="element-250" data-mp="3a68idmh2dbua">
                  <Building2 size={28} strokeWidth={1.5} data-id="element-251" data-mp="362k98zcsa86x" />
                </div>
                <h3 className="font-serif font-bold text-lg mb-2 text-brand-charcoal" data-id="element-252" data-mp="3jxml034barrn">
                  Centralized Delivery
                </h3>
                <p className="text-sm text-brand-charcoal/80 leading-relaxed" data-id="element-253" data-mp="3ttzdwys191lc">
                  CBU and 4C systems
                </p>
              </a>

              <a href="/6m8/commercial-mailboxes-lockers/parcel-lockers.html" className="bg-white border border-brand-border hover:border-brand-maroon/40 hover:shadow-sm transition-all rounded-xl p-6 lg:p-8 flex flex-col items-center text-center group" data-id="element-254" data-mp="3oumr2e15vuir">
                <div className="w-14 h-14 bg-brand-goldSoft text-brand-maroon rounded-full flex items-center justify-center mb-5 group-hover:scale-110 transition-transform" data-id="element-255" data-mp="28h5112hwihlw">
                  <Package size={28} strokeWidth={1.5} data-id="element-256" data-mp="j0sonw59nbv0" />
                </div>
                <h3 className="font-serif font-bold text-lg mb-2 text-brand-charcoal" data-id="element-257" data-mp="nzdnbr4vdnhc">
                  Parcel lockers
                </h3>
                <p className="text-sm text-brand-charcoal/80 leading-relaxed" data-id="element-258" data-mp="a6xs3ci7mtqz">
                  Secure package management
                </p>
              </a>

              <a href="/6m8/commercial-mailboxes-lockers/replacement-commercial-locks-hinges-doors.html" className="bg-white border border-brand-border hover:border-brand-maroon/40 hover:shadow-sm transition-all rounded-xl p-6 lg:p-8 flex flex-col items-center text-center group" data-id="element-259" data-mp="8qcoy3kkjr3">
                <div className="w-14 h-14 bg-brand-goldSoft text-brand-maroon rounded-full flex items-center justify-center mb-5 group-hover:scale-110 transition-transform" data-id="element-260" data-mp="3rgcgqru7ao8h">
                  <Wrench size={28} strokeWidth={1.5} data-id="element-261" data-mp="1pohj3g4s4k99" />
                </div>
                <h3 className="font-serif font-bold text-lg mb-2 text-brand-charcoal" data-id="element-262" data-mp="2ykwgzbo32ni9">
                  Replacement parts
                </h3>
                <p className="text-sm text-brand-charcoal/80 leading-relaxed" data-id="element-263" data-mp="2tl9zgq182l3n">
                  Commercial doors, locks, and hardware
                </p>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}